import { render, staticRenderFns } from "./ListSupplies.vue?vue&type=template&id=7521e8d7&scoped=true"
import script from "./ListSupplies.vue?vue&type=script&lang=js"
export * from "./ListSupplies.vue?vue&type=script&lang=js"
import style0 from "./ListSupplies.vue?vue&type=style&index=0&id=7521e8d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7521e8d7",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/Supplies/Existence/ListSupplies.vue
// module id = 2141
// module chunks = 31